import ReactStrapTable from "components/reactStrapTable";
import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { dateFormate, currencyFormat, cellRendererCheck } from "utils/columns";
import CellOptions from "components/reactStrapTable/components/CellOptions";
import View from "assets/icon/icon-icon-options-view-patient.svg";
import ViewHover from "assets/icon/icon-icon-options-view-patient_hover.svg";
import Loader from "components/Loader";
import useAxios from "hooks/useAxios";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import HoverImage from "react-hover-image/build";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import plus from "assets/icon/plus-icon.svg";
import Drawer from "components/Drawer";
import AddCrosswalkActiveMapings from "../AddCrosswalk";
import { toast } from "react-toastify";
import { cloneDeep } from "lodash";
import GCNHyperLink from "components/GCNHyperLink";
import { ModuleAccess } from "utils/moduleaccess";
import { faL } from "@fortawesome/free-solid-svg-icons";

let rowForEdit = {};
let mapingstas = ["UnmappedNDC", "Active", "UnMappedChargeCode"];

const AutoMappingTable = (props) => {
  const {
    collapseSider,
    toggleSider,
    autoMappingTableData,
    automappingTotalrecords,
    setLoading,
    refetch,
    automappingsearch,
    AutoMapcolumnFilters,
    onPageChange,
    onSearchColumnFilters = () => "",
    loading,
    setAutoMappingTableData,
    orgId,
    setAutoMappingTotalrecords,
    resetFilterFlag,
    SetResetFilterFlag

  } = props;

useEffect(()=>{
setGcnFlag(false);
setAddMapings(false);
},[orgId])
  

  const API = useAxios();
  //    const [tableData, setTableData] = useState(dummyData);
  const [addmapings, setAddMapings] = useState(false);
  const [activeflag, setActiveFlag] = useState(false)
  const [gcnflag, setGcnFlag] = useState(false)
  const [gcndata, setGcnData] = useState({})

  const handelAddMaping = (hasrefetch) => {
    setAddMapings(!addmapings);
    if (hasrefetch == true) {
      fetchCrossAutoMapping();
    }

  };
  const editRow = (rowData, isEdit = true) => {
    debugger;
    //  console.log(rowData,"rOWdATA IN EDIT rOW   ");
    if (isEdit == false) {
      fetchCrossAutoMapping();
    }
    let tempData = [...autoMappingTableData];
    console.log(tempData, "tempData in Edit Row");
    tempData = tempData.map((row) => {
      // debugger;
      row.isEdit = false;
      if (row.chargeCodeGCNMapID === rowData?.chargeCodeGCNMapID && isEdit) {
        row.isEdit = isEdit;
        // row.endDate=dateFormate(row.endDate)
        rowForEdit = row;
        // console.log(rowForEdit, "rowForEdit in edit Row");
        // console.log(row, "row in edit Row");
      }
      return row;
    });
    // setTouched('');
    // setReasonErr(false);
    // updatedFields = {};
    setAutoMappingTableData(tempData);
  };

  const saveUpdateRow = async (rowData) => {
    debugger;
    setLoading(true)
    let payload = { ...rowForEdit };
    payload.inActiveFlag = rowData.inActiveFlag
    delete payload.isEdit;
    try {
      const result = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/updateChargeCodeGCN/${rowData?.chargeCodeGCNMapID}`,
        payload,
        {
          hasDefaultURL: true,
        }
      );

      if (result.data == true) {
        toast.success('updated successfully');
        refetch(true);
        //  editRow(rowData,false)
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };

  //   const cellRenderEdit = (row) => {
  //       return <CellOptions row={row} onEdit={editRow} onSave={saveUpdateRow}/>;
  //};
  const cellRenderEdit = (rowData) => {
    if (hasPermission('ED')) {
      if (rowData.isEdit) {
        return (
          <div className="d-flex align-items-center">
            <Button
              className="text-primary p-0 text-decoration-none"
              color="link"
              onClick={() => saveUpdateRow(rowData)}
            >
              <HoverImage
                key="SaveIcon"
                src={SaveIcon}
                hoverSrc={SaveHoverIcon}
                alt=""
              />
            </Button>
            <Button
              className="text-primary p-0 text-decoration-none"
              color="link"
              onClick={() => editRow(rowData, false)}
            >
              <HoverImage
                key="CancelIcon"
                src={CancleIcon}
                hoverSrc={CancleHoverIcon}
                alt=""
              />
            </Button>
          </div>
        );
      }
      return (
        <div className="d-flex align-items-center">
          {renderEditButton(rowData)}
        </div>
      );
    }
  };
  const renderEditButton = (rowData) => {
    // debugger;
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => editRow(rowData)}
        disabled={rowData?.chargeAutomappingFlag == "N"}
        title="Edit"
      >
        <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
      </Button>
    );
  };
  const updateRowValue = (value, col) => {
    debugger;
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
    console.log("Updated row:", rowForEdit);
  };

  const hasPermission = (code) => {
    return ModuleAccess("CRW", code);
  };
  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    if (formatterType == "date") {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          //hasTouched={hasTouched}
          endDateFormatter={true}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
        />
      );
    } else {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
        // alwaysEditableCheckbox={alwaysEditableCheckbox}
        />
      );
    }
  };
  //   const handleSwitch=(e,item)=>{
  //     const checked=e.target.checked
  //     setAutoMappingTableData(item.inActive==checked==true?"Y":"N")

  //     setActiveFlag(item.inActive==checked==true?"Y":"N")

  //   }

  const handleSwitch = (e, item) => {
    debugger;
    const checked = e.target.checked;
    const newValue = checked ? "N" : "Y";

    setAutoMappingTableData(prev =>
      Array.isArray(prev)
        ? prev.map(obj =>
          obj.chargeCodeGCNMapID === item.chargeCodeGCNMapID
            ? { ...obj, inActiveFlag: newValue }
            : obj
        )
        : prev
    );

    //   setActiveFlag(newValue);
  };

  const handelAutoMapping = (row) => {
    return (
      <FormGroup switch>
        <Input
          type="switch"
          role="switch"
          name="inActive"
          id="inActive"
          className="f-14 m-auto"
          style={{ margin: "auto" }}
          disabled={!(row.isEdit == true && row?.chargeAutomappingFlag == "Y")}
          //   value={activeflag}
          checked={row.inActiveFlag === "N" ? true : false}
          onChange={(e) => handleSwitch(e, row)}
        />
      </FormGroup>
    );
  };
  const cellRenderLink = (row) => {
    return (
      <>
        <span
          className='text-decoration-underline d-inline-block cursor-pointer'
          onClick={() => handelGCN(row)}
        >
          {row.gcnSequenceNumber}
        </span>
      </>
    )
  }
  const handelGCN = (row) => {
    debugger;
    setGcnFlag(!gcnflag);
    setGcnData(row);
  }

  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 118,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "inActiveFlag",
      text: "Active",
      cellRenderer: (rowData) => handelAutoMapping(rowData),
      width: 70,
      show: true,
      disabled: true,
      edit: true,
      hideColFilter: false,
      action: true,
    },

    {
      dataField: "gcn",
      text: "GCN",
      sort: true,
      width: 100,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRenderLink(row),
    },
    {
      dataField: "chargeCode",
      text: "Charge Code",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.chargeCode),
    },
    {
      dataField: "chargeDescription",
      text: "Charge Description",
      sort: false,
      width: 272,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.chargeDescription),
    },
    {
      dataField: 'createdByID',
      text: 'Created By',
      sort: false,
      width: 160,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.createdByID),
    },
    {
      dataField: "createdDate",
      text: "Created Date",
      sort: true,
      width: 160,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.createdDate),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 170,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => dateFormate(row.modifiedDate),
    },
  ];

  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {

    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {

    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const handleFilterCancel = () => {
    refetch(true);
  };
  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      // setColFilters(colFilter);
    }
  };
  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(automappingsearch);
    if (AutoMapcolumnFilters && AutoMapcolumnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...AutoMapcolumnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "crosswalkautomappings";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  }


  const fetchCrossAutoMapping = async () => {
    debugger;

    if (!orgId?.tenantID) return null;
    if (
      window.selectedCoveredEntittyId == "" ||
      window.selectedCoveredEntittyId == undefined
    )
      return null;
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/AutoMappingAll`,
        automappingsearch,
        { hasDefaultURL: true }
      );
      if (data?.items?.length > 0) {
        setAutoMappingTableData(data.items);
        setAutoMappingTotalrecords(data.totalRecords);
        setLoading(false);
      } else {
        setAutoMappingTableData([]);
        setAutoMappingTotalrecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  return (
    <div>
      {/* {loading && <Loader opacity={0.01} />} */}

      <div className="d-flex justify-content-between">
        <h5 className="f-18 text-primary font-weight-600">
          Automapping ({automappingTotalrecords})
        </h5>
        <Button
          size="sm"
          color="primary"
          className="ms-auto upload_btn"
          // style={{marginRight:"10px",padding:"2px 8px"}}
          hidden={!(hasPermission('AD'))}
          disabled={autoMappingTableData.length == 0 || autoMappingTableData[0]?.chargeAutomappingFlag == 'N'}
          onClick={handelAddMaping}
        >
          {" "}
          <span
            className=""
            style={{ paddingRight: "4px", position: "relative", top: "-1px" }}
          >
            <img src={plus} alt="" />
          </span>
          Add
        </Button>
      </div>

      <hr />
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          autoMappingTableData.length > 0
            ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
            : "default"
        }
      >
        <ReactStrapTable
          id="crosswalk-automapping"
          height={550}
          fixedColumn
          width={1200}
          // reset={reset}
          hasPagination={autoMappingTableData.length > 0 ? true : false}
          data={autoMappingTableData}
          columns={mainCol}
          onExport={handleExport}
          filters={automappingsearch}
          totalRecords={automappingTotalrecords}
          pageSize={automappingsearch.pageSize}
          currentPage={automappingsearch.currentPage}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          //accuntErr={accuntErr}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
          showtoggle={true}
          resetFilterFlag={resetFilterFlag}
          SetResetFilterFlag={SetResetFilterFlag}
        />
      </div>
      <Drawer
        direction="end"
        isOpen={addmapings}
        toggle={handelAddMaping}
        size="md"
        title="New Mapping"
      >
        <AddCrosswalkActiveMapings orgId={orgId} automappingsearch={automappingsearch} handelAddMaping={handelAddMaping} setLoading={setLoading} loading={loading} />
      </Drawer>

      <Modal
        isOpen={gcnflag}
        toggle={handelGCN}
        size="lg"
        className="lg"
      >
        <ModalHeader toggle={handelGCN}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            NDC List
          </h5>
        </ModalHeader>
        <ModalBody className="m-2 p-2">
          <GCNHyperLink orgId={orgId} automappingsearch={automappingsearch} gcndata={gcndata} />


        </ModalBody>

      </Modal>

    </div>
  );
};

export default AutoMappingTable;
